import styles from './Spinner.module.css';

export const Spinner = ({ size }: { size?: number }) => {
  return (
    <div
      style={
        size !== undefined ? { width: `${size}px`, height: `${size}px` } : {}
      }
      className={styles.loader}
    >
      Loading...
    </div>
  );
};
